<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import newScoresAPI from "../../../services/newScores/newScoresAPI"
import Swal from "sweetalert2";
import ItemAPI from "@/services/items/itemsAPI";
import matrizLegalAPI from "../../../services/standards/matrizLegal/matrizLegalAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import MatrizImplementacionPagination from "../../../components/standard/matrizLegal/MatrizImplementacionPagination.vue";

export default {
  page: {
    title: "Matriz legal",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    MatrizImplementacionPagination
  },
  data() {
    return {
      title: "2.7.1 Matriz legal",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Matriz legal",
          active: true,
        },
      ],

      item: null,
      itemStatus: "No cumplido",
      loading: true,
      itemData: null,
      companieList: [],

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
    }
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(18)
        .then((response) => {
          this.itemData = response;
          this.loading = false
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 18)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID = this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions
        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 18,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          this.loading = false;
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            icon: "success",
            type: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
        })
        .catch((error) => {
          this.loading = false;
          Swal.fire({
            title: "¡ERROR!",
            text: "¡No se ha actualizado el estado del ítem!",
            icon: "error",
            type: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    fetch() {
      this.$refs.paginator.query();
    },

    getCompanieList() {
      matrizLegalAPI.listCompany(this.companyID)
        .then((response) => {
          this.companieList = response.data.data
          this.loading = false
        })
        .catch((error) => {
          console.log(error);
          this.loading = false
        });
    },

    saveImplementacion(dato, check) {
      let meets = check === 'meets' ? 1 : 0;
      let fails = check === 'fails' ? 1 : 0;
      let data = {
        matriz_legal_id: dato.id,
        companies_id: this.companyID,
        apply: 1,
        meets: meets,
        fails: fails,
      };
      matrizLegalAPI.updateImplementacion(dato.id, data)
        .then((response) => {
          const itemChange = {
            companies_id: this.companyID,
            item_id: 18,
            status: 'Pendiente',
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              this.loading = false;
              Swal.fire({
                title: "¡Éxito!",
                text: "¡Norma actualizada con éxito!",
                icon: "success",
                type: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              this.getCompanieList();
            })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    }

  },
  mounted() {
    this.getItemData();
    this.getCompanieList();
    this.getItems();
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">

              <div class="row">
                <div class="col-12 text-right m-b-0 mb-2">
                  <button @click="goBack" id="goback" class="btn btn-secondary m-l-5 ml-1">
                    <i class="fas fa-arrow-left"></i>
                  </button>
                  <b-tooltip target="goback" placement="left">Volver</b-tooltip>
                </div>
              </div>

              <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>

              <div class="form-row col-12">
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Tipo de norma</th>
                      <th class="text-center align-middle">Numero</th>
                      <th class="text-center align-middle">Año</th>
                      <th class="text-center align-middle">articulos aplicables</th>
                      <th class="text-center align-middle">Expedida por</th>
                      <th class="text-center align-middle">descripcion de la norma</th>
                      <th class="text-center align-middle">Evidencia de cumplimiento</th>
                      <th class="text-center align-middle">Cumple</th>
                      <th class="text-center align-middle">No cumple</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr v-for="dato in companieList" :key="dato.id">
                      <td>{{ dato.standar_name }}</td>
                      <td class="text-center align-middle">{{ dato.standard_number }}</td>
                      <td>{{ dato.year }}</td>
                      <td class="text-center align-middle">{{ dato.applicable_items }}</td>
                      <td>{{ dato.issued_by }}</td>
                      <td class="text-center align-middle">{{ dato.description_standard }}</td>
                      <td>{{ dato.evidence_compliance }}</td>
                      <td class="text-center align-middle">
                        <input name="meets" type="checkbox" :checked="dato.meets === 1"
                          @click="() => saveImplementacion(dato, 'meets')">
                      </td>
                      <td class="text-center align-middle">
                        <input name="fails" type="checkbox" :checked="dato.fails === 1"
                          @click="() => saveImplementacion(dato, 'fails')">
                      </td>
                    </tr>
                  </tbody>
                </table>
                <MatrizImplementacionPagination ref="paginator" @fetch="(items) => (lista = items)" />
              </div>

            </div>
          </div>
        </div>
        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>